(function () {
  let swipers = [];
  const mql = window.matchMedia('(min-width: 1280px)'); // Tailwind xl

  const isVisible = (el) =>
    !!el &&
    el.offsetParent !== null &&
    window.getComputedStyle(el).display !== 'none';

  const destroySwipers = () => {
    swipers.forEach((s) => {
      try {
        s.destroy(true, true);
      } catch (e) {}
    });
    swipers = [];
  };

  const initAll = () => {
    destroySwipers();

    document.querySelectorAll('[data-blog-list]').forEach((section) => {
      // pick the visible swiper (mobile always; desktop only if layout = carousel)
      const container = Array.from(
        section.querySelectorAll('.blog-list-swiper'),
      ).find((el) => isVisible(el));
      if (!container) return;

      // ensure pagination element exists (progressbar)
      let paginationEl = container.querySelector('.swiper-pagination');
      if (!paginationEl) {
        paginationEl = document.createElement('div');
        paginationEl.className = 'swiper-pagination';
        container.appendChild(paginationEl);
      }

      // navs (present in header; hidden on desktop grid via Tailwind)
      const nextEl =
        section.querySelector(
          '.blog-list-swiper-buttons .blog-list-button-next',
        ) || undefined;
      const prevEl =
        section.querySelector(
          '.blog-list-swiper-buttons .blog-list-button-prev',
        ) || undefined;
      const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

      const swiper = new window.Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation,
        pagination: {
          el: paginationEl,
          clickable: true,
          type: 'progressbar',
        },
        watchOverflow: false, // keep progressbar even with few slides
        observer: true,
        observeParents: true,
        on: {
          afterInit(sw) {
            sw.pagination.render && sw.pagination.render();
            sw.pagination.update && sw.pagination.update();
          },
          resize(sw) {
            sw.pagination.update && sw.pagination.update();
          },
        },
      });

      swipers.push(swiper);
    });
  };

  // init + lifecycle
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', destroySwipers);

  // re-init when crossing xl breakpoint
  if (mql.addEventListener) mql.addEventListener('change', initAll);
  else if (mql.addListener) mql.addListener(initAll);
})();
